module.exports = __webpack_public_path__ + "static/seo-bdad512bd4b880d737b28ee0e4cb75b0.png";